import { inject, Injectable } from '@angular/core';
import { APP_MENU } from './../../app.menu';
import { MenuItem } from './../models/menu-item.model';
import { AuthService } from './auth.service';


@Injectable({ providedIn: 'root' })
export class MenuService {

    private authService = inject(AuthService);

    getMenu(): MenuItem[] {
        const roles = this.authService.getRoles();
        return this.filterMenu(APP_MENU, roles);
    }

    private filterMenu(items: MenuItem[], roles: string[]): MenuItem[] {
        return items
            .filter(item => !item.role || roles.includes(`${item.role}:active`) || roles.includes(`${item.role}:disabled`))
            .map(item => ({
                ...item,
                disabled: !roles.includes(`${item.role}:active`),
                children: item.children ? this.filterMenu(item.children, roles) : []
            }));
    }
}
